import React from 'react';
import { useLocation } from 'react-router-dom';
import { CustomBackdrop, Header, NavHeader, Page, SubmitButton } from '../../../../../../../components';
import { ChannelBoxIcon } from '../../../../../components/channel/box-icon';
import { useCalibration } from '../../common/hooks/use-calibration';
import './index.scss';

const ZfBidiCalibrationSuccess: React.FC = () => {
  const { state } = useLocation();
  const { channel, navigate, t } = useCalibration();

  const handleClick = () => {
    if (state?.back) navigate(-state.back);
    else navigate(-7);
  };

  return (
    <Page
      className="calibration-flow"
      isStickyHeader
      whiteContent
      header={
        <>
          <NavHeader />
          <Header title={t('exalus.calibration')} />
        </>
      }
    >
      {channel && <ChannelBoxIcon channel={channel} className="facade-icon" />}
      <p className="channel-name">{channel?.Name}</p>
      <p className="info m-t-40">{t('exalus.params.ZfBidiParams.calibrationFlow.calibrationSuccess')}</p>
      <SubmitButton type="button" onClick={handleClick} tranparent>
        OK
      </SubmitButton>
      {!channel && <CustomBackdrop loading />}
    </Page>
  );
};

export default ZfBidiCalibrationSuccess;
